import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=e21fb18c&"
import script from "./Link.vue?vue&type=script&lang=js&"
export * from "./Link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\YrtDev\\wms\\wms-site\\main\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e21fb18c')) {
      api.createRecord('e21fb18c', component.options)
    } else {
      api.reload('e21fb18c', component.options)
    }
    module.hot.accept("./Link.vue?vue&type=template&id=e21fb18c&", function () {
      api.rerender('e21fb18c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/components/Sidebar/Link.vue"
export default component.exports